import { render, staticRenderFns } from "./ViewUserPage.vue?vue&type=template&id=4b70c529"
import script from "./ViewUserPage.vue?vue&type=script&lang=js"
export * from "./ViewUserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports